import React from 'react';
import {useTranslation} from 'react-i18next';
import {useStravaExport} from '../hooks/useStravaExport';

export function StravaExportButton({workoutId}: {workoutId: number}) {
  const {t} = useTranslation();
  const {state, busy, error, load} = useStravaExport(workoutId);
  if (!state && !error) return null;
  const completed = state?.status === 'completed';
  const status = state?.error_code === 'activity_removed' ? 'removed' : state?.error_code === 'reconnect' ? 'reconnect' : state?.status ?? 'ready';
  const send = ['ready', 'uncertain', 'pending', 'sending', 'processing'].includes(status) || (status === 'reconnect' && state?.can_send === true);
  return <div style={{padding: '8px 20px', fontSize: 13}} aria-live="polite">
    {completed && /^\d+$/.test(String(state?.activity_id)) ?
      <a href={`https://www.strava.com/activities/${state?.activity_id}`} target="_blank" rel="noopener noreferrer" style={{color: '#FC5200'}}>{t('stravaExport.view')}</a> : <>
      {status === 'ready' && <p>{t('stravaExport.privacy')}</p>}
      {status !== 'ready' && <p>{t(`stravaExport.${status}`, {defaultValue: t('stravaExport.pending')})}</p>}
      <button type="button" disabled={busy} onClick={() => void load(send)} style={{color: '#FC5200', padding: '8px 14px', border: '1px solid currentColor', borderRadius: 8, background: 'transparent', cursor: 'pointer'}}>
        {t(busy ? 'stravaExport.busy' : status === 'ready' ? 'stravaExport.send' : 'stravaExport.check')}
      </button>
    </>}
    {error && <p role="alert">{t('stravaExport.error')}</p>}
  </div>;
}
